import HttpMethod_vue_vue_type_script_setup_true_lang_default from "./HttpMethod.vue_vue_type_script_setup_true_lang.js";
//#region src/components/HttpMethod.vue
var HttpMethod_default = HttpMethod_vue_vue_type_script_setup_true_lang_default;
//#endregion
export { HttpMethod_default as default };

//# sourceMappingURL=HttpMethod.vue.js.map